export default __webpack_public_path__ + "static/media/kitchen-pack-3.e8925a54.png";